import { GridCellKind, type Item, type TextCell } from "@artis/data-grid";

import type { Draft } from "./hooks/useEditSession";

type CellContentDeps = {
  getSource: (cell: Item) => string;
  getDisplay: (cell: Item) => string;
};

export function cellContent(cell: Item, draft: Draft | null, { getSource, getDisplay }: CellContentDeps): TextCell {
  const isDraft = draft !== null && cell[0] === draft.cell[0] && cell[1] === draft.cell[1];
  return {
    kind: GridCellKind.Text,
    data: isDraft ? draft.text : getSource(cell),
    displayData: getDisplay(cell),
    allowOverlay: false,
  };
}
